import React, { useContext } from "react"
import LocaleContext, { LocaleProvider } from "../context/LocaleContext"
import Layout from "../common/layout/layout"
import SEO from "../common/seo/seo"
import ForHealthCoachContainer from "../modules/forHealthCoach/ForHealthCoachContainer"
import { graphql } from "gatsby"
import translate, { keys } from "../translation/translator"

const ForHealthCoach = ({ data }) => {
  const locale = useContext(LocaleContext)
  return (
    <Layout>
      <SEO
        title={translate(keys.FOR_HEALTH_COACH_META_TITLE, locale)}
        description={translate(keys.FOR_HEALTH_COACH_META_DESCRIPTION, locale)}
      />
      <LocaleProvider>
        <ForHealthCoachContainer
          images={data.healthCoachPageImages.edges}
          healthCoachHelpImages={data.healthCoachHelpImages.edges}
          healthCoachProgramImages={data.healthCoachProgramImages.edges}
          healthCoachHeaderImage={data.healthCoachHeaderImage.edges}
        />
      </LocaleProvider>
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    healthCoachHeaderImage: allFile(
      filter: { relativeDirectory: { eq: "healthCoachHeaderImage" } }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyImageSharpFluid
            }
            id
          }
        }
      }
    }

    healthCoachHelpImages: allFile(
      filter: { relativeDirectory: { eq: "healthCoachHelpImages" } }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyImageSharpFluid
            }
            id
          }
        }
      }
    }

    healthCoachPageImages: allFile(
      filter: { relativeDirectory: { eq: "healthCoachPageImages" } }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyImageSharpFluid
            }
            id
          }
        }
      }
    }

    healthCoachProgramImages: allFile(
      filter: { relativeDirectory: { eq: "healthCoachProgramImages" } }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyImageSharpFluid
            }
            id
          }
        }
      }
    }
  }
`

export default ForHealthCoach
